import { Component, OnInit, Inject, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ComboSearchPipe } from 'src/app/shared/pipes/combo-search.pipe';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LoadingService } from 'src/app/shared/service/loading.service';
import { ErrorService } from 'src/app/shared/service/error.service';
import { DialogService } from 'src/app/shared/service/dialog.service';
import { FdFieldConfigs } from 'src/app/shared/fd-form-components/fd-form-components.module';
import { FdSelectConfig, Item } from 'src/app/shared/fd-form-components/fd-select/fd-select.component';
import { takeWhile, tap } from 'rxjs/operators';
import { Messages } from 'src/app/shared/messages/messages';
import { ModalDefinitions, FdAlertComponent } from 'src/app/shared/fd-form-components/fd-alert/fd-alert.component';
import { MccModel, MccPhysicalPersonSaveModel} from '../../models/mcc-physical-person.model';
import { MccService } from '../../services/mcc.service';
import { AuthService } from 'src/app/shared/service/auth.service';

@Component({
    selector: 'app-add-mcc',
    templateUrl: './add-mcc.component.html',
    styleUrls: ['./add-mcc.component.scss'],
    standalone: false
})
export class AddMccComponent implements OnInit, OnDestroy {
  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  fieldsArray: FdFieldConfigs[] = new Array<FdFieldConfigs>();
  selectedInstitution: string;
  actualMcc: string;
  alive = true;
  toggleMessage: string;
  comboSearchPipe: ComboSearchPipe;
  @ViewChild('mccSelect', { static: false, read: ElementRef }) mccSelectRef: ElementRef;
  private scrollListenerAdded = false;

  ngOnInit() {
    this.formGroup = this.createFormGroup();
    this.fields = this.createFields();
    this.comboSearchPipe = new ComboSearchPipe();
  }

  ngAfterViewChecked() {
    const panel = document.querySelector('.mat-select-panel');
    if (panel && !this.scrollListenerAdded) {
      panel.addEventListener('scroll', this.onDropdownScroll.bind(this));
      this.scrollListenerAdded = true;
    }
    if (!panel) {
      this.scrollListenerAdded = false;
    }
  }

  onDropdownScroll(event: Event) {
    const element = event.target as HTMLElement;
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 1) {
      this.onComboScroll();
    } 
  }

  handleDropdownScroll(event: Event) {
    const target = event.target as HTMLElement;
    if (target.scrollHeight - target.scrollTop <= target.clientHeight + 1) {
      this.onComboScroll();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const panel = document.querySelector('.mat-select-panel');
      if (panel) {
        panel.addEventListener('scroll', this.handleDropdownScroll.bind(this));
      }
    }, 500);
  }


  ngOnDestroy() {
    this.alive = false;
  }


  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<AddMccComponent>,
    private loadingService: LoadingService,
    private errorService: ErrorService,
    private dialogService: DialogService,
    private mccService: MccService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: {
      institution: string;
      serviceContract: number;
      search?: (institution: string, serviceContract: number) => void;
    },
    private dialog: MatDialog
  ) { }

  public isFormGroupValid(formGroup?: UntypedFormGroup): boolean {
    const formToBeValidated = !!formGroup ? formGroup : this.formGroup;
    if (formToBeValidated.invalid) {
      this.showErrorMessages(formToBeValidated);
      return false;
    }
    return true;
  }

  private allMccItems: Item[] = [];
  private mccDisplayLimit = 50;

  public addMccStatusForm(activity: Partial<MccModel> = {}) {
    if (this.mccStatusArray.length > 0 && !this.isFormGroupValid()) {
      return;
    }

    const newlyCreatedFieldGroup = this.fieldsArray.push(this.createFields());
    this.mccStatusArray.push(this.createMccStatusForm(activity));
  }

  public get mccStatusControls() {
    return this.mccStatusArray.controls;
  }

  protected createFormGroup() {
    return this.formBuilder.group({
      mcc: [{ value: '', disabled: true }, Validators.required],
      serviceContract: ['', Validators.required],
      institution: ['', Validators.required],
    });
  }
  
  createFields(): FdFieldConfigs {
    return {
      institution: {
      label: 'Nº Instituição',
      controlName: 'institution',
      maskCharsReplace: /[. / -]/g,
      panelWidth: '320px',
      messages: {
        required: 'Informe uma instituição',
        invalid: 'Usuário inválido'
      }
      },
      serviceContract: {
      label: 'Service Contract',
      controlName: 'serviceContract',
      maskCharsReplace: /[. / -]/g,
      panelWidth: '320px',
      messages: {
        required: 'Informe um service contract',
        invalid: 'Usuário inválido'
      }
      },
      mcc: {
      label: 'MCC',
      controlName: 'mcc',
      items: [],
      searchable: true,
      searchPlaceholder: 'Insira o MCC',
      panelWidth: '320px',
      messages: {
        required: 'campo obrigatório'
      },
      }
    };
  }

  changeSelectedInstitution(institution: string) {
    this.mccDropdown.items = [];
    this.allMccItems = [];
    this.selectedInstitution = institution;


    const mccControl = this.formGroup.get('mcc');
    if (this.selectedInstitution != null && this.selectedInstitution !== '') {
      mccControl.enable();
      this.getMccList(this.selectedInstitution);
    } else {
      mccControl.disable();
      this.allMccItems = [];
      this.mccDropdown.items = [];
    }
  }

  selectedMcc(mcc: string) {
    this.actualMcc = mcc;
  }


  save() {

    if (
      !this.formControls.mcc.value ||
      !this.formControls.institution.value ||
      !this.formControls.serviceContract.value
    ) {
          this.dialogService.openDialog( Messages.REQUIRED_CONDITIONAL_FIELD_ERROR);
        return;
    }

    let saveModel: MccPhysicalPersonSaveModel = new MccPhysicalPersonSaveModel(); 
  
    saveModel.mcc = this.formControls.mcc.value;
    saveModel.institution = this.formControls.institution.value;
    saveModel.serviceContract = this.formControls.serviceContract.value;

    this.loadingService.show();

    this.mccService
      .saveMccPhysicalPerson(saveModel)
      .subscribe(response => {
        this.loadingService.hide();

        const successDialogRef = this.dialog.open(FdAlertComponent, {
          disableClose: true,
          width: ModalDefinitions.DEFAULT_MODAL_WIDTH,
          data: Messages.EDIT_SAVE_SUCCESS
        });

        successDialogRef.afterClosed().subscribe(() => {
          this.dialogRef.close({
            institution: saveModel.institution,
            serviceContract: saveModel.serviceContract
          });
        });
      }, error => {
        this.loadingService.hide();
        this.errorService.handleXHRError(error, Messages.GENERAL_ERROR);
      });
        
  }

  onComboScroll() {
  const currentLength = this.mccDropdown.items.length;
    if (currentLength < this.allMccItems.length) {
      const nextItems = this.allMccItems.slice(currentLength, currentLength + this.mccDisplayLimit);
      this.mccDropdown.items = [...this.mccDropdown.items, ...nextItems];
    }
  }

  onMccSearch(searchText: string) {
  if (!searchText || searchText.trim() === '') {
    this.mccDropdown.items = this.allMccItems.slice(0, this.mccDisplayLimit);
    return;
  }
    const filtered = this.comboSearchPipe.transform(this.allMccItems, searchText, 'label');
    this.mccDropdown.items = filtered.slice(0, this.mccDisplayLimit);
  }


  getMccList(institution: string) {

  const userData = this.authService.getUserData();
  const userId = userData && userData.sub ? userData.sub : 'default';
  const cacheKey = `mccList_${userId}_${institution}`;
  const cached = localStorage.getItem(cacheKey);
  const FIFTEEN_MINUTES = 900000;
  if (cached) {
    try {
      const cacheData = JSON.parse(cached);
      if (
        Array.isArray(cacheData.items) &&
        cacheData.items.length > 0 &&
        typeof cacheData.timestamp === 'number'
      ) {
        if (Date.now() - cacheData.timestamp < FIFTEEN_MINUTES) {
          this.mccDropdown.items = cacheData.items.slice(0, this.mccDisplayLimit);
          setTimeout(() => {
            this.allMccItems = cacheData.items;
          }, 0);
          return;
        } else {
          if (localStorage.getItem(cacheKey)) {
            localStorage.removeItem(cacheKey);
          }
        }
      }
    } catch (e) {
      if (localStorage.getItem(cacheKey)) {
        localStorage.removeItem(cacheKey);
      }
    }
  }

  this.mccService.getMccList(institution)
    .pipe(takeWhile(() => this.alive))
    .subscribe(mccList => {
      if (Array.isArray(mccList) && mccList.length > 0) {
        this.mccDropdown.items = mccList.slice(0, this.mccDisplayLimit);
        setTimeout(() => {
          this.allMccItems = mccList;
          const cacheData = { items: mccList, timestamp: Date.now() };
          localStorage.setItem(cacheKey, JSON.stringify(cacheData));
        }, 0);
      } else {
        this.allMccItems = [];
        this.mccDropdown.items = [];
      }
    }, error => {
      this.mccDropdown.items = [];
      this.allMccItems = [];
    });
}

  
  close() {
    this.dialogRef.close();
  }

  get hasServiceContract() {
    return this.formControls.serviceContract && this.formControls.serviceContract.value;
  }

  get mccDropdown() {
    return this.fields.mcc as FdSelectConfig;
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }
  
  private get mccStatusArray(): UntypedFormArray {
    return this.formControls.mccStatusForms as UntypedFormArray;
  }

  private showErrorMessages(formToBeValidated: UntypedFormGroup | UntypedFormArray) {
      let control;
      Object.keys(formToBeValidated.controls)
        .reverse()
        .forEach(field => {
          control = formToBeValidated.get(field);
          if (control instanceof UntypedFormArray ||
            control instanceof UntypedFormGroup) {
            this.showErrorMessages(control);
          } else {
            if (control && control.invalid) {
              control.markAsTouched();
            }
          }
        });
    }

  private createMccStatusForm(mccModel: Partial<MccModel>): UntypedFormGroup {
    const formGroup = this.formBuilder.group({
      mcc: [mccModel.mcc]

    });

    formGroup.controls.mcc.setValidators(
      [Validators.required]
    );
      return formGroup;
    }

}
